





































import { Component, Vue, Watch } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import { companyServer, temporaryWorkServer } from '@/api/installServer';

@Component({
  components: {},
  mixins: [TableStripe],
})
export default class AddDialog extends Vue {
  private visible = false;
  type: any = '';
  canEdit = false; // 详情的时候不可编辑

  formData: any = {
    content: '',
    startTime: '',
    endTime: '',
  };

  userRules: any = {
    startTime: [{ required: true, message: '请选择作业开始时间' }],
    endTime: [{ required: true, message: '请选择作业结束时间' }],
    content: [{ required: true, message: '请填写作业内容' }],
  };

  private async showAddDialog(type: any, data?: any) {
    this.type = type;
    this.visible = true;
    if (this.type === 'add') {
      this.canEdit = false;
      this.formData = {
        content: '',
        startTime: '',
        endTime: '',
      };
    }
    if (this.type === 'detail') {
      this.formData = data;
      this.canEdit = true;
    }
    if (this.type === 'edit') {
      this.formData = data;
      this.canEdit = false;
    }
  }
  /**
   * @description 点击返回按钮 关闭弹窗
   */
  closeDialog() {
    this.visible = false;
    (this.$refs.form as any).clearValidate();
    this.canEdit = false;
  }

  /**
   * @description 点击保存按钮
   */
  saveDialog() {
    const formComponent: any = this.$refs.form;
    formComponent.validate((valid: any) => {
      if (valid) {
        switch (this.type) {
          case 'add':
            this.saveFunctionData();
            break;
          case 'edit':
            this.saveFunctionData();
        }
      }
    });
  }

  /**
   * 【接口】行内新增功能
   */
  private async saveFunctionData() {
    if (this.type === 'add') {
      await temporaryWorkServer
        .temporaryWorkPermitSaveOrUpdateData({ ...this.formData })
        .then((res: any) => {
          this.$message.success('成功新增了一条数据！');
          this.closeDialog();
          this.$emit('refreshData');
        })
        .catch((error: any) => {
          // console.log(error);
          this.$message.warning('新增数据失败！');
        });
    }
    if (this.type === 'edit') {
      await temporaryWorkServer
        .temporaryWorkPermitSaveOrUpdateData({ ...this.formData })
        .then((res: any) => {
          this.$message.success('成功修改当前数据！');
          this.closeDialog();
          this.$emit('refreshData');
        })
        .catch((error: any) => {
          // console.log(error);
          this.$message.warning('修改数据失败！');
        });
    }
  }
}
